import * as React from 'react';
import {
  Datagrid,
  List,
  ListProps,
  TextField,
  useTranslate,
} from 'react-admin';
import TestTypeField from '../../../components/Fields/TestTypeField';
import PartnerField from '../../../components/Fields/PartnerField';
import Paginator from '../../../components/Paginator';
import { TESTS_PER_PAGE } from '../../../constants/pagination';

import './styles.scss';

const CardiovascularAndDiabetesRiskCheckList = (props: ListProps) => {
  const translate = useTranslate();

  return (
    <List
      {...props}
      bulkActionButtons={false}
      actions={false}
      empty={<div className="error">{translate('testResults.noTests')}</div>}
      pagination={<Paginator perPage={TESTS_PER_PAGE} />}
      perPage={TESTS_PER_PAGE}
    >
      <Datagrid rowClick="show">
        <TestTypeField source="type" label="tests.type" />
        <TextField
          sortable={false}
          emptyText="-"
          source="code"
          label="tests.code"
        />
        <TextField
          sortable={false}
          source="user.fullName"
          label="testResults.fullName"
          emptyText="-"
        />
        <PartnerField source="partnerCode" label="tests.columns.partners" />
      </Datagrid>
    </List>
  );
};

export default CardiovascularAndDiabetesRiskCheckList;
